import { render } from "./PrivacyContent.vue?vue&type=template&id=6c3203b3&scoped=true"
const script = {}

import "./PrivacyContent.vue?vue&type=style&index=0&id=6c3203b3&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3203b3"]])

export default __exports__